export class CommonTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        laggTillNyttAnbudKontrakt: "Skapa nytt anbud & kontrakt",
        nyttSkogsvardsuppdrag: "Skapa nytt skogsvårdsuppdrag",
        sok: "Sök",
        sokAnbudKontrakt: "Sök anbud & kontrakt",
        angeAnsvarigVirkeskopare: "Ange ansvarig virkesköpare",
        kontraktnr: "Nummer",
        kontraktbenamning: "Benämning",
        avtalsnr: "Avtalsnr",
        affarsform: "Affärsform",

        Kontrakttyp: "Kontrakttyp",
        leverantor: "Leverantör",
        kontraktstatus: "Status",
        giltighetstid: "Giltighetstid",
        senastAndrad: "Senast ändrad",
        makulera: "Makulera",
        makuleraKontrakt: "Makulera kontrakt",
        makuleraKontraktConfirm: "<b>Obs! Du behöver alltid kontakta Virkesekonomi om kontraktet har överförts till Vacs innan du makulerar kontraktet.</b>" +
        "<br>Om arbetsorder finns kommer samtliga att tas bort." +
        "<br>Är du säker på att du vill makulera kontrakt ",
        makuleraKontraktConfirmFPV: "Är du säker på att makulera kontrakt ",
        kontraktetHarMakulerats: "Kontraktet har makulerats"
    };
}
